<template>
    <section class="section hero my-6">
        <div class="container is-flex">
            <div class="card pa-2" :style="computedStyle">
                <div class="card-content">
                    <h2
                        class="cp-title-2 mb-2 text-center has-text-centered"
                        :style="computedFont"
                    >Níveis e Beneficios</h2>

                    <div class="cp-line-lh" style="background-color: white">
                        <div :style="blurPrimaryColor" class="cp-line-lh"></div>
                    </div>

                    <section class="mt-6" v-for="(level, index) in levelsWithBenfits" :key="index">
                        <!-- Show only mobile -->
                        <div class="is-hidden-tablet">
                            <div class="centralize">
                                <div class="cp-circle is-flex" style="background-color: white">
                                    <span class="cp-circle is-flex" :style="blurPrimaryColor">
                                        <p class="is-size-2 has-text-weight-bold">
                                            {{ `0${index + 1}` }}
                                        </p>
                                    </span>
                                </div>

                                <div v-if="!hidePoints" class="my-3 has-text-weight-semibold is-size-6">
                                    Pontuação necessária:
                                    <span class="has-text-weight-semibold is-size-6">
                                        {{level.trigger_amount}}
                                    </span>
                                </div>
                            </div>

                            <div>
                                <div style="background-color: white" :style="computedTitleBox" class="level-title my-2">
                                    <div :style="blurPrimaryColor" class="level-title">
                                        <p class="cp-title-4" :style="computedFont">{{ level.name }}</p>
                                    </div>
                                </div>
                            </div>
                            <p class="has-text-justified">{{ level.description }}</p>

                                <div class="mb-6 centralize" v-if="level.benefits.length">
                                <p class="cp-title-4 mt-4" :style="computedFont">Benefícios</p>

                                <div v-for="benefit in level.benefits" :key="benefit.id" class="centralize">
                                    <div>
                                        <div class="is-flex my-2">
                                            <img
                                                v-if="benefit.icon_url"
                                                class="image is-64x64 mr-3"
                                                :src="benefit.icon_url"
                                                :alt="level.prize.name"
                                            />
                                            <p class="cp-title-6 mt-2" :style="computedFont">
                                                {{ benefit.name }}
                                            </p>
                                        </div>
                                    </div>
                                    <div class="mb-5">
                                        <p class="is-size-6">
                                            {{ benefit.description }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Show in touchable and desktop screens  -->
                        <div class="is-hidden-mobile">  
                            <div class="has-text-justified"> 
                                <div :class="(index % 2 == 0) ? 'is-flex' : 'rigth'" class="my-5"> 
                                    <div class="cp-circle mx-3" style="background-color: white">
                                        <span class="cp-circle is-flex" :style="blurPrimaryColor">
                                            <p class="is-size-2 has-text-weight-bold">{{`0${index + 1 }`}}</p>
                                        </span>
                                    </div>
                                    <div>
                                        <p class="cp-title-4" :style="computedFont">{{ level.name }}</p>
                                        <p v-if="!hidePoints" class="has-text-weight-semibold">
                                            Pontuação necessária: 
                                            <span>
                                                {{ level.trigger_amount}}
                                            </span>
                                        </p>
                                    </div>

                                </div>
                                    <p class="mb-6" style="max-width: 48rem">{{ level.description }}</p>
                                
                                <div v-if="level.benefits.length" class="my-6 mx-3">
                                    <p class="cp-title-4 has-text-left mb-5" :style="computedFont">Beneficios</p>

                                    <div v-for="benefit in level.benefits" :key="benefit.id">

                                   <div>
                                        <div class="is-flex my-2">
                                            <img
                                                v-if="benefit.icon_url"
                                                class="image is-64x64 mr-3"
                                                :src="benefit.icon_url"
                                                :alt="level.prize.name"
                                            />
                                            <p class="cp-title-6 mt-2" :style="computedFont">
                                                {{ benefit.name }}
                                            </p>
                                        </div>
                                        <div class="mb-5">
                                        <p class="is-size-6" style="max-width: 22rem">
                                            {{ benefit.description }}
                                        </p>
                                        </div>
                                    </div>
                                </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    data: () => ({
        levelsWithBenfits: [],
    }),
    created() {
        this.setBenefitInfoInLevels()
    },
    computed: {
        ...mapGetters({
            styles: 'company/landing_page_colors',
            levels: 'level/levels',
            benefits: 'benefit/benefits',
            hidePoints: 'company/hide_points',
        }),
        computedStyle() {
            return {
                color: this.styles.card_font_color,
                'background-color': this.styles.card_background_color,
            }
        },
        computedFont() {
            return {
                color: this.styles.card_font_color,
            }
        },
        computedTitleBox(){
           return {
               'border': `.15rem solid ${this.styles.card_font_color}`,
           } 
        },
        blurPrimaryColor() {
            const alpha = 0.5
            const [r, g, b] = this.styles.card_background_color
                .match(/\w\w/g)
                .map((x) => parseInt(x, 16))

            return {
                'background-color': `rgba(${r},${g},${b},${alpha})`,
            }
        },
    },
    methods: {
        setBenefitInfoInLevels() {
            this.levels.forEach((level) => {
                const findBenefits = this.benefits
                    .filter((benefit) => benefit.level_id == level.id)

                this.levelsWithBenfits.push({
                ...level,
                benefits: findBenefits ? findBenefits : null,
                })
            })
        },
    },
};
</script>

<style scoped>
.card-content {
    display: flex;
    flex-direction: column;

    justify-content: center;
    align-items: center;
    text-align: center;
}
.centralize {
    display: flex;
    flex-direction: column;
    align-items: center;
}
.level-title{
    border-radius: .5rem;
    max-width: 22rem;
    margin: 0 auto;
}
.rigth{
    display: flex;
    flex-direction: row-reverse;
    margin-left: 10.65rem;
}
@media screen and (min-width: 769px) {
    .card{
        padding: 1.33rem !important;
    }
    .card-content {
        padding: 2rem;
        align-items: start;
        max-width: 52.25rem;
    }
}
</style>